import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgBrazilValidators, MASKS } from 'ng-brazil';
import { SecurityService } from 'src/app/services/security.service';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { Reset } from 'src/app/models/reset';
import { Router, ActivatedRoute } from '@angular/router';
import { Confirm } from 'src/app/models/confirm';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

    public resetFormGroup: FormGroup;
    public MASKS = MASKS;

    constructor(
        private formBuilder: FormBuilder, 
        private securityService: SecurityService,
        private alertService: NewAlertService, 
        private router: Router,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.resetFormGroup = this.formBuilder.group({
            email: new FormControl('', [
                Validators.required, Validators.email
            ]),
            cpf: new FormControl('', [
                Validators.required,
                NgBrazilValidators.cpf
            ])
        });
    }

    get form() { return this.resetFormGroup.controls; }

    onSubmit(reset: Reset) {
        if (this.resetFormGroup.valid) {
            reset.cpf = reset.cpf.replace(/\D+/g, '').replace(' ', '');
            this.securityService.recuperar(reset).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.securityService.changeRecuperacao(new Confirm(reset.email, reset.cpf, '', '', ''));
                        this.alertService.success(response.message, true);
                        this.router.navigate(['confirm'], { relativeTo: this.route.parent });
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    //this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                    console.log(error);
                    this.alertService.error('Ocorreu um erro ao tentar resetar a senha! Tente novamente mais tarde.');
                }
            );
        }
    }
}
